export default "__VITE_ASSET__BDQqvmqD__"